/* eslint-disable */
export default function teamValidation(e, msgContainer, key) {
    msgContainer[key] = [];
    msgContainer['isError'] = false;
    let UsersSelected = e;
    let res = '';
    for(let i = 0 ; i < UsersSelected.length ; i++){
        res =  /\S+@\S+\.\S+/.test(UsersSelected[i]);
    }
    if(UsersSelected.length < 1){
        msgContainer[key].push('*Required');
        msgContainer['isError'] = true;
    }else if(res === false){
        msgContainer[key].push('* Users Must be Valid Email Address');
        msgContainer['isError'] = true;
    }
}
